import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnBoardRoutingModule } from './on-board-routing.module';
import { OnBoardComponent } from './on-board.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { CoreUiModule } from '../shared/core-ui.module';
import { RouterModule } from '@angular/router';
import { ConfirmCompanyComponent } from './confirm-company/confirm-company.component';
import { SelectIndustryComponent } from './select-industry/select-industry.component';
import { CustomizeWorkspaceComponent } from './customize-workspace/customize-workspace.component';
import { LoaderComponent } from './loader/loader.component';
import { provideLottieOptions, LottieComponent } from 'ngx-lottie';

@NgModule({
  imports: [
    CommonModule,
    CoreUiModule,
    RouterModule,
    OnBoardRoutingModule,
    LottieComponent
],
  declarations: [
    OnBoardComponent,
    SetPasswordComponent,
    ConfirmCompanyComponent,
    SelectIndustryComponent,
    CustomizeWorkspaceComponent,
    LoaderComponent
  ],
  providers: [
    provideLottieOptions({
      player: () => import('lottie-web'),
    })
  ]
})
export class OnBoardModule { }
